<template>
    <v-layout class="header-menu" row>
        <v-flex xs8 class="hotel-name d-inline-flex">
            <v-menu offset-y class="hotel-list" content-class="hotel-list__content" v-if="selectedRoom != null">
                <template v-slot:activator="{ attrs, on }">
                    <div
                        class="hotel-list__title"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <div class="title-block">
                            <span>{{ selectedRoom.name }}</span>
                        </div>
                        <div
                            v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')"
                            class="d-inline-flex"
                        />
                    </div>
                </template>
                <v-list class="hotel-list__list">
                    <v-radio-group v-model="selectedRoom" link>
                        <v-list-item v-for="item in roomList" :key="item.uid">
                            <v-list-item-content>
                                <v-radio
                                    :label="item.name"
                                    :value="item"
                                />
                            </v-list-item-content>
                        </v-list-item>
                    </v-radio-group>
                </v-list>
            </v-menu>
        </v-flex>
        <v-flex class="dashboard">
            <div
                class="dashboard__icon"
                @click="openNotificationList"
            >
                <div v-html="require('!html-loader!@/assets/icons/notification_icon.svg')" class="d-inline-flex" />
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: "HomeTitle",
    props: {
        value: {
            type: Object,
        },
    },
    data() {
        return {
            selectedRoom: null,
            roomList: [],
        };
    },
    mounted() {
        this.getHomes();
    },
    watch: {
        selectedRoom(val) {
            if (val) {
                this.$emit("input", val);
                this.$store.commit('setHome', val);
            } else {
                this.$store.commit('setHome', null);
            }
        },
    },
    methods: {
        openNotificationList() {
            this.$router.push({ name: "notificationList" });
        },
        getHomes() {
            this.$http.get('/homes/home/homes/')
                .then((res) => {
                    this.roomList = res.data.results;
                    if (this.$store.getters.home) {
                        if (this.$store.getters.home.uid) {
                            this.selectedRoom = this.roomList.find(room => room.uid == this.$store.getters.home.uid);
                            return;
                        }
                        this.selectedRoom = this.roomList.find(room => room.uid == this.$store.getters.home);
                    }
                    if ((!this.selectedRoom || this.selectedRoom == -1) && this.roomList.length) {
                        this.selectedRoom = this.roomList[0];
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
}
</script>

<style lang="scss">
.hotel-list__list.v-list {
    background-color: var(--dark-black-2);
    min-width: 250px;

    .v-label {
        font-weight: 400;
        font-size: 15px;
        line-height: 22px;
        color: var(--dark-white);
    }

    .v-input--selection-controls {
        margin: 0;
        min-height: 34px;

        &__input,
        .v-messages {
            display: none;
        }

        .v-input__slot {
            margin: 0;
        }

        .v-list-item {
            min-height: 34px;
            max-height: 34px;

            &__content {
                padding: 0;
            }
        }
    }
}
</style>